import { jsx as _jsx } from "react/jsx-runtime";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import React from "react";
import { Context } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Context";
import { assignSettingOnEvent } from "@faire/retailer/settings/assignSettingOnEvent";
export var NoOpLayoutElement = function() {
    var _React_useContext = React.useContext(Context), layout_element_data_assign_settings_on_client_view = _React_useContext.layoutElement.layout_element_data_assign_settings_on_client_view;
    var viewRef = useDoActionWhenVisible(function() {
        layout_element_data_assign_settings_on_client_view.forEach(function(setting) {
            assignSettingOnEvent(setting);
        });
    });
    return /*#__PURE__*/ _jsx("div", {
        "data-test-id": "no-op-layout-element",
        ref: viewRef
    });
};
